/* istanbul ignore file */
/* tslint:disable */

export enum PrivacyEnum {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
